import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useEffect,
} from 'react';
import useGetInvitedJobs from '../hooks/dashboard/jobs/invite/useGetInvitedJobs';

interface InvitedJobsSearchContextType {
  keyword: string;
  setKeyword: (v: string) => void;
  payInterval: string;
  setPayInterval: (v: string) => void;
  location: string;
  setLocation: (v: string) => void;
  page: string;
  setPage: (v: string) => void;
  perPage: string;
  setPerPage: (v: string) => void;
  loading: boolean;
}

const InvitedJobsSearchContext = createContext<InvitedJobsSearchContextType>({
  keyword: '',
  setKeyword: () => {},
  payInterval: '',
  setPayInterval: () => {},
  location: '',
  setLocation: () => {},
  page: '1',
  setPage: () => {},
  perPage: '10',
  setPerPage: () => {},
  loading: false,
});

export const InvitedJobsSearchProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const { getInvitedJobs: fetchInvitedJobs, loading } = useGetInvitedJobs();

  const [keyword, setKeyword] = useState<string>('');
  const [payInterval, setPayInterval] = useState<string>('');
  const [location, setLocation] = useState<string>('');
  const [page, setPage] = useState<string>('1');
  const [perPage, setPerPage] = useState<string>('10');

  // 🔥 whenever ANY of these change, run the fetch with the *latest* values
  useEffect(() => {
    fetchInvitedJobs({ keyword, payInterval, location, page, perPage });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyword, payInterval, location, page, perPage]);

  return (
    <InvitedJobsSearchContext.Provider
      value={{
        keyword,
        setKeyword,
        payInterval,
        setPayInterval,
        location,
        setLocation,
        page,
        setPage,
        perPage,
        setPerPage,
        loading,
      }}
    >
      {children}
    </InvitedJobsSearchContext.Provider>
  );
};

export const useInvitedJobsSearch = () => useContext(InvitedJobsSearchContext);
